<template>
  <div class="relative flex items-baseline">
    <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 163.4 222.87" class="w-6">
      <path
        fill="currentColor"
        class="cls-1"
        d="M127.01,41.88C125.16,18.48,105.57,0,81.7,0S38.25,18.48,36.4,41.88H0V222.87H163.4V41.88h-36.39ZM81.7,6.76c20.14,0,36.72,15.45,38.55,35.12H43.16c1.83-19.67,18.41-35.12,38.54-35.12h0Zm74.95,209.36H6.76V48.64H156.65V216.11h0Z"
      />
    </svg>
    <span class="cart-count text-xs">{{ cartCounter }}</span>
  </div>
</template>
<script lang="ts" setup>
import { toRefs } from 'vue'
const props = defineProps({
  cartCounter: Number,
})
const { cartCounter } = toRefs(props)
</script>
<style>
.cart-count {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-75%, -25%);
  text-align: center;
}
</style>
